import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ShrimpCursor from "./components/ShrimpCursor";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductPage from "./pages/ProductPage";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import About from "./pages/About";
import Delivery from "./pages/Delivery";
import Promotions from "./pages/Promotions";
import Contacts from "./pages/Contacts";
import Profile from "./pages/Profile";
import Favorites from "./pages/Favorites";
import ScrollToTop from "./ScrollToTop";
import "./App.css";

function App() {
	return (
		<AuthProvider>
			<CartProvider>
				<BrowserRouter>
					<ScrollToTop />
					<div className="App">
						<ShrimpCursor />
						<Header />
						<main>
							<Routes>
								<Route path="/" element={<Home />} />
								<Route path="/catalog" element={<Catalog />} />
								<Route path="/product/:id" element={<ProductPage />} />
								<Route path="/cart" element={<Cart />} />
								<Route path="/checkout" element={<Checkout />} />
								<Route
									path="/order-success/:orderId"
									element={<OrderSuccess />}
								/>
								<Route path="/about" element={<About />} />
								<Route path="/delivery" element={<Delivery />} />
								<Route path="/promotions" element={<Promotions />} />
								<Route path="/contacts" element={<Contacts />} />
								<Route path="/profile" element={<Profile />} />
								<Route path="/favorites" element={<Favorites />} />
							</Routes>
						</main>
						<Footer />
						<Toaster richColors position="top-right" />
					</div>
				</BrowserRouter>
			</CartProvider>
		</AuthProvider>
	);
}

export default App;
